<template>
  <div class="value-buy-card">
    <div class="value-buy-header">
      <img class="value-buy-title" :src="titleImg" alt="超值换购" />
      <span class="value-buy-subtitle">{{ subtitle }}</span>
    </div>
    <div :class="['value-buy-list', valueBuyListClass]">
      <div
        v-for="(packageItem, index) in displayPackageList"
        :key="optionKey(packageItem, index)"
        :class="[
          'value-buy-option',
          { 'value-buy-option-disabled': packageItem.selectType === 3 },
        ]"
        @click.stop="selectPackageItem(packageItem)"
      >
        <div :class="['value-buy-subject', subjectClass(packageItem)]">
          <div class="value-buy-name">
            {{ displaySubjectName(packageItem) }}
          </div>
          <img
            class="value-buy-check"
            :src="packageItem.selectType === 2 ? checkedImg : uncheckedImg"
            alt=""
          />
        </div>
        <div class="value-buy-price">
          <span class="value-buy-price-symbol">¥</span>
          <span class="value-buy-price-sale">{{ buyPrice(packageItem) }}</span>
          <span v-if="originPrice(packageItem)" class="value-buy-price-origin">
            ¥{{ originPrice(packageItem) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getCommonLog } from "../../changeCourse/utils/point";
import { appendStuCourseIds } from "@/common/script/log-helper";

const SUBJECT_CLASS_MAP = {
  74: "value-buy-option-red",
  108: "value-buy-option-blue",
  109: "value-buy-option-purple",
  110: "value-buy-option-green",
  113: "value-buy-option-yellow",
};

export default {
  inject: {
    cardType: {
      default: "",
    },
    getCurrentDiscount: {
      default: () => () => ({}),
    },
  },
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState({
      stateContCourseData: (state) => state.contCourseData,
    }),
    packageList() {
      return this.info?.package_info || [];
    },
    displayPackageList() {
      return this.packageList.slice(0, 4);
    },
    valueBuyListClass() {
      const count = Math.min(Math.max(this.displayPackageList.length, 1), 5);
      return `value-buy-list-${count}`;
    },
    subtitle() {
      const titleInfo = this.info?.title_info || {};
      if (Object.prototype.hasOwnProperty.call(titleInfo, "act_desc")) {
        return titleInfo.act_desc || "";
      }
      return "";
      // if (titleInfo.subtitle) {
      //   return titleInfo.subtitle;
      // }
      // const total = this.packageList.length || titleInfo.total_num || 0;
      // return `${total}款可选，立享10元换购系统课`;
    },
  },
  data() {
    return {
      titleImg:
        "https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/value_buy.png",
      checkedImg:
        "https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/box_checked.png",
      uncheckedImg:
        "https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/box_unchecked.png",
      hasLoggedValueBuyShow: false,
    };
  },
  methods: {
    optionKey(packageItem, index) {
      return `${packageItem.product_type}_${packageItem.product_id}_${index}`;
    },
    courseInfo(packageItem) {
      return (
        packageItem?.product_list?.find((product) => product.type === 100) || {}
      );
    },
    subjectInfo(packageItem) {
      return this.courseInfo(packageItem)?.extra_info || {};
    },
    subjectName(packageItem) {
      return (
        this.subjectInfo(packageItem).subject_name || packageItem.name || ""
      );
    },
    displaySubjectName(packageItem) {
      return Array.from(this.subjectName(packageItem)).slice(0, 6).join("");
    },
    getRelatedMainProductId(packageItem = {}) {
      return (packageItem?.parent || "").split("_")?.[1] || "";
    },
    getValueBuyCardType() {
      if (this.displayPackageList.length <= 1) {
        return 1;
      }
      if (this.displayPackageList.length === 2) {
        return 2;
      }
      return 3;
    },
    getValueBuyProductInfoList() {
      return this.displayPackageList.map((item) => {
        const info = {};
        if (+item?.product_type === 100) {
          info.subject_id = item?.product_list?.[0]?.extra_info?.subject_id;
          info.term_id = item?.product_list?.[0]?.extra_info?.term_ids;
        }
        info.resale = item?.price?.sale_price;
        return {
          product_id: item?.product_id,
          product_type: item?.product_type,
          parent: item?.parent,
          info,
        };
      });
    },
    getValueBuyShowParams() {
      const firstPackage = this.displayPackageList[0] || {};
      return appendStuCourseIds({
        show_time: Date.now(),
        respos_type: 2,
        subject_name: this.displayPackageList
          .map((item) => this.subjectName(item))
          .filter(Boolean)
          .join(","),
        promotion_id: this.info?.title_info?.promotion_id || "",
        respos_card_type: this.getValueBuyCardType(),
        // related_main_product_id: this.getRelatedMainProductId(firstPackage),
        related_main_product_id_list: this.getValueBuyProductInfoList(),
      });
    },
    logValueBuyAreaShow() {
      if (this.hasLoggedValueBuyShow || this.displayPackageList.length === 0) {
        return;
      }
      this.hasLoggedValueBuyShow = true;
      window.__XES_LOG__?.loadMsg({
        show_id: "renewal_center_exchange_section_show",
        show_name: "超值换购区域曝光",
        params: this.getValueBuyShowParams(),
      });
    },
    subjectClass(packageItem) {
      const subjectId = +this.subjectInfo(packageItem).subject_id;
      return SUBJECT_CLASS_MAP[subjectId] || "value-buy-option-red";
    },
    salePrice(packageItem) {
      return packageItem?.price?.sale_price;
    },
    buyPrice(packageItem) {
      const { selectType, price = {} } = packageItem;
      if (
        +selectType === 2 &&
        (price.promotion_price || price.promotion_price === 0)
      ) {
        return price.promotion_price;
      }
      if (+selectType === 2 && (price.buy_price || price.buy_price === 0)) {
        return price.buy_price;
      }
      return this.salePrice(packageItem);
    },
    buyPriceBySelectType(packageItem, selectType) {
      return this.buyPrice({
        ...packageItem,
        selectType,
      });
    },
    originPrice(packageItem) {
      if (+packageItem?.selectType !== 2) {
        return "";
      }
      const origin = packageItem?.price?.sale_price;
      return origin || origin === 0 ? origin : "";
    },
    addLog(packageItem) {
      const nextSelectType = packageItem.selectType === 2 ? 1 : 2;
      this.$xesLogger.clickMsg({
        params: {
          click_id: "renewal_center_exchange_card_click",
          click_name: "换购科目卡片勾选",
          click_time: Date.now(),
          ...getCommonLog(packageItem),
          is_selected: nextSelectType === 2,
          ...(nextSelectType === 2 && {
            premium_exchange_price: this.buyPriceBySelectType(
              packageItem,
              nextSelectType
            ),
          }),
        },
      });
    },
    selectPackageItem(packageItem) {
      this.addLog(packageItem);
      if (packageItem.selectType === 3) {
        this.$toast({
          message: `${packageItem.status?.tips || "不可勾选"}`,
        });
        return;
      }
      packageItem.cardType = this.cardType;
      this.$EventBus.$emit("selectOne", packageItem);
    },
  },
  mounted() {
    this.logValueBuyAreaShow();
  },
};
</script>

<style lang="less" scoped>
.value-buy-card {
  padding: 12px;
  background: #fff;
  border-radius: 16px;
}

.value-buy-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.value-buy-title {
  height: 24px;
  object-fit: contain;
}

.value-buy-subtitle {
  margin-top: 2px;
  color: #999;
  font-family: PingFang SC;
  font-size: 13px;
  line-height: 18px;
}

.value-buy-list {
  display: flex;
  margin-top: 12px;
  // overflow-x: auto;
}

.value-buy-list::-webkit-scrollbar {
  display: none;
}

.value-buy-option {
  flex: 0 0 54px;
  height: 79px;
  margin-right: 6px;
}

.value-buy-option:last-child {
  margin-right: 0;
}

.value-buy-list-1 .value-buy-option {
  flex-basis: 100%;
}

.value-buy-list-2 .value-buy-option {
  flex-basis: calc((100% - 6px) / 2);
}

.value-buy-list-3 .value-buy-option {
  flex-basis: calc((100% - 12px) / 3);
}

.value-buy-list-4 .value-buy-option {
  flex-basis: calc((100% - 18px) / 4);
}

.value-buy-list-5 .value-buy-option {
  flex-basis: calc((100% - 24px) / 5);
}

.value-buy-option-red {
  background: linear-gradient(135deg, #ff6461 0%, #f93834 100%);
}

.value-buy-option-blue {
  background: linear-gradient(135deg, #70b0ff 0%, #4096ff 100%);
}

.value-buy-option-purple {
  background: linear-gradient(135deg, #9f92ff 0%, #7f6dfe 100%);
}

.value-buy-option-green {
  background: linear-gradient(135deg, #57e7b1 0%, #00cf82 100%);
}

.value-buy-option-yellow {
  background: linear-gradient(135deg, #ffa432 0%, #ff8e00 100%);
}

.value-buy-option-disabled {
  opacity: 0.45;
}

.value-buy-subject {
  position: relative;
  display: flex;
  // align-items: center;
  height: 56px;
  // padding-left: 10px;
  border-radius: 12px;
  box-sizing: border-box;
  color: #fff;
}

.value-buy-name {
  color: #fff;
  // margin-left: 10px;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 600;
  margin: 10px 9px 0 10px;
  overflow: hidden;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-break: break-all;
}

.value-buy-check {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 28px;
  height: 28px;
}

.value-buy-price {
  display: flex;
  align-items: baseline;
  margin-top: 5px;
  color: #f93834;
  white-space: nowrap;
}

.value-buy-price-symbol {
  font-family: DIN-Bold-700;
  font-size: 13px;
}

.value-buy-price-sale {
  font-family: DIN-Bold-700;
  font-size: 19px;
}

.value-buy-price-origin {
  margin-left: 4px;
  color: rgba(51, 51, 51, 0.35);
  font-family: DIN-Bold-700;
  font-size: 11px;
  // text-decoration: line-through;
}
</style>
